import Logins from '../Auth/Signin';
import ErrorPage1 from '../Components/Pages/ErrorPages/ErrorPage400';
import ErrorPage2 from '../Components/Pages/ErrorPages/ErrorPage401';
import ErrorPage3 from '../Components/Pages/ErrorPages/ErrorPage403';
import ErrorPage4 from '../Components/Pages/ErrorPages/ErrorPage404';
import Error500 from '../Components/Pages/ErrorPages/ErrorPage500';
import Error503 from '../Components/Pages/ErrorPages/ErrorPage503';

export const authRoutes = [
  { path: `${process.env.PUBLIC_URL}/login`, Component: <Logins /> },
  { path: `${process.env.PUBLIC_URL}/err400`, Component: <ErrorPage1 /> },
  { path: `${process.env.PUBLIC_URL}/err401`, Component: <ErrorPage2 /> },
  { path: `${process.env.PUBLIC_URL}/err403`, Component: <ErrorPage3 /> },
  { path: `${process.env.PUBLIC_URL}/err404`, Component: <ErrorPage4 /> },
  { path: `${process.env.PUBLIC_URL}/err500`, Component: <Error500 /> },
  { path: `${process.env.PUBLIC_URL}/err503`, Component: <Error503 /> },
];